import React from 'react';
// Images
import LeftCross from '../../assets/images/logos/mistress-md-professional-dominatrix-cross-logo-right-side-no-background.png';
import RightCross from '../../assets/images/logos/mistress-md-professional-dominatrix-cross-logo-left-side-no-background.png';

function GeneralHeader({
  title,
  subtitle,
  imageUrl,
  imageText,
  imageAlt,
  children,
}) {
  return (
    <header className='grid w-full'>
      <div className='grid px-6 sm:px-8 md:px-12 pt-10 lg:container lg:mx-auto'>
        <article>
          <section className='text-center'>
            <h1 className='font-StencilW01 text-[2.5rem] xs:text-5xl md:text-6xl lg:text-8xl xl:text-9xl text-colour5 font-medium tracking-widest uppercase'>
              {title}
            </h1>
            <h2 className='text-lg'>{subtitle}</h2>
          </section>
          <section className='px-2 pt-4'>
            <div className='bg-colour5 rounded-tl-2xl rounded-tr-2xl relative px-2 py-2 mx-auto w-fit'>
              <img
                src={imageUrl}
                alt={imageAlt}
                className='w-full max-w-lg rounded-tl-2xl rounded-tr-2xl mx-auto h-auto'
              />
              <div className='absolute text-center left-1/2 top-1/2 transform w-full -translate-x-1/2 -translate-y-1/2'>
                <span className='font-StencilW01 text-5xl w-full text-colour1'>
                  {imageText}
                </span>
              </div>
            </div>
          </section>
        </article>
      </div>
      <section className='grid lg:grid-cols-a1a gap-4 pt-12 lg:pt-16 text-lg'>
        <div className='hidden lg:grid'>
          <img src={LeftCross} alt='Left cross' />
        </div>
        <div className='grid gap-4 px-6 sm:px-10 md:px-16 text-center'>
          {/* Children */}
          {children}
        </div>
        <div className='hidden lg:grid'>
          <img src={RightCross} alt='Right cross' />
        </div>
      </section>
    </header>
  );
}

export default GeneralHeader;
